import React, { useRef, useContext } from 'react';
import { isInRole } from '../../Utils/roleChecker';
import { UserRole } from '../../Constants/constants';
import { UserContext } from '../../Context/UserContext';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import EntityPage from '../../Layout/EntityPage';
import { IOverrideEntityActions } from '../../API/Interfaces/IEntityActions';
import ILocationBasicDto from '../../API/Interfaces/ILocationBasicDto';
import LocationsServiceAPI from '../../API/Services/LocationServiceAPI';
import { Query, QueryResult, Column } from 'material-table';
import ILocationDetailsDto from '../../API/Interfaces/ILocationDetailsDto';
import ISearchBaseDto from '../../API/Interfaces/ISearchBaseDto';
import AppLink from '../../Layout/Components/AppLink';
import { routes } from '../../Routing/routes';

export const Locations = () => {
	const { enqueueSnackbar } = useSnackbar();
	const { t } = useTranslation();
	const tableRef = useRef();
	const userContext = useContext(UserContext);
	const errorDialog = (message?: string) =>
		enqueueSnackbar(`${t('common.errorOccured')}${message ? ': ' : ''}${message && message}`, { variant: 'error' });
	let headers;

	const basicHeaders: Array<Column<ILocationBasicDto>> = [
		{
			title: t('locations.table.nameHeader'),
			field: 'name',
			defaultSort: 'asc',
			render: (rowData) => {
				return <AppLink to={routes.locationDetails.replace(':id', rowData.id)}>{rowData.name}</AppLink>;
			},
		},
		{
			title: t('locations.table.dealerHeader'),
			field: 'dealername',
			render: (rowData) => <span>{rowData.dealerName}</span>,
		},
		{
			title: t('locations.table.corporationHeader'),
			field: 'corporationname',
			render: (rowData) => <span>{rowData.corporationName}</span>,
		},
		{
			title: t('locations.table.addressHeader'),
			field: 'address',
		},
		{
			title: t('report.StartDate'),
			field: 'startDate',
			sorting: false,
			render: () => <span>{'n/a'}</span>,
		},
		{
			title: t('report.EndDate'),
			field: 'endDate',
			sorting: false,
			render: () => <span>{'n/a'}</span>,
		},
	];

	const EntityActions: IOverrideEntityActions<ILocationDetailsDto, ILocationBasicDto> = {
		api: LocationsServiceAPI,
		presetDataCallback: (data: any) => {
			return data;
		},
		getTableData: async function (query: Query<ILocationBasicDto>) {
			const result: QueryResult<ILocationBasicDto> = {
				data: [],
				page: 0,
				totalCount: 0,
			};
			const request: ISearchBaseDto = {
				itemsPerPage: query.pageSize,
				pageNumber: query.page ? query.page + 1 : 1,
				searchPhrase: query.search,
				sortColumn: '',
				sortDirection: '',
			};

			if (query.orderBy) request.sortColumn = query.orderBy.field as string;

			if (query.orderDirection) request.sortDirection = query.orderDirection;

			try {
				const response = await EntityActions.api.GetPage(request);
				if (response.success) {
					result.data = response.data.items;
					result.page = response.data.currentPage - 1;
					result.totalCount = response.data.totalItemsCount;
					return result;
				} else {
					let message = t(`errorCodes.${response.errors[0].errorCode}`);
					enqueueSnackbar(`${t('common.errorOccured')}: ${message}`, { variant: 'error' });
				}
			} catch (e) {
				errorDialog(e.message);
			}
			return result;
		},
	};

	if (isInRole(userContext.userRoles, UserRole.SuperAdmin)) {
		headers = basicHeaders;
	} else if (isInRole(userContext.userRoles, UserRole.DealerAdmin)) {
		headers = basicHeaders.filter((t) => t.field !== 'dealer');
	} else {
		headers = basicHeaders.filter((t) => t.field !== 'dealer' && t.field !== 'corporation');
	}

	const tableProps: any = {
		columns: headers,
		options: { paging: true },
	};

	let entityPageProps = {
		tableRef: tableRef,
		EntityActions: EntityActions,
		headers: headers,
		pageTitle: t('menu.location'),
		tableProps: tableProps,
		disableAddNew: true,
		isDetails: false, //props.isInDetails,
		//firstColumn: props.isInDetails ? 'name' : undefined,
	};

	return <EntityPage {...entityPageProps} />;
};
